import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { formsV2 as Forms } from '@breezeway/brzw-components';

const KEY_CODES = {
  ENTER: 13,
  ESC: 27,
};

const TextAreaFormik = props => {
  const {
    additionalProps,
    className,
    disabled,
    field,
    form,
    id,
    label,
    maxRows,
    placeholder,
    shouldSubmitFormOnBlur,
    theme,
    type,
  } = props;
  const textareaInputRef = useRef(null);
  const { errors, setFieldValue, submitCount, touched, handleSubmit, resetForm } = form;
  const { name } = field;
  let hasError = false;
  let errorName = null;
  const shouldHandleError = (touched[name] || submitCount > 0) && errors[name];

  const handleEscAndEnter = useCallback(event => {
    const { keyCode } = event;
    switch (keyCode) {
      case KEY_CODES.ENTER: {
        _.invoke(event, 'preventDefault');
        _.invoke(textareaInputRef, 'current.blur');
        break;
      }
      case KEY_CODES.ESC: {
        resetForm();
        _.invoke(textareaInputRef, 'current.blur');
        break;
      }
      default: {
        break;
      }
    }
  }, []);

  const removeEventListener = () =>
    _.invoke(window, 'removeEventListener', 'keydown', handleEscAndEnter);

  useEffect(() => () => removeEventListener(), []);

  const onFocusTextArea = () => {
    if (shouldSubmitFormOnBlur) _.invoke(window, 'addEventListener', 'keydown', handleEscAndEnter);
  };
  const onBlurTextArea = () => {
    if (shouldSubmitFormOnBlur) {
      removeEventListener();
      if (errors[name]) {
        resetForm();
      } else {
        handleSubmit();
      }
    }
  };

  if (shouldHandleError) {
    hasError = true;
    errorName = errors[name];
  }

  return (
    <Forms.Textarea
      {...field}
      additionalSubText={errorName}
      className={className}
      disabled={disabled}
      iconAfter={hasError && 'info-outline'}
      id={id || name}
      labelText={label}
      maxRows={maxRows}
      onBlurInput={onBlurTextArea}
      onChange={changedValue => setFieldValue(name, changedValue)}
      onFocusInput={onFocusTextArea}
      placeholderText={placeholder}
      textareaInputRef={textareaInputRef}
      theme={theme}
      type={type}
      withError={hasError}
      {...additionalProps}
    />
  );
};

TextAreaFormik.propTypes = {
  additionalProps: PropTypes.shape({}),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({}),
  form: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  maxRows: PropTypes.number,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  shouldSubmitFormOnBlur: PropTypes.bool,
  theme: PropTypes.string,
  type: PropTypes.string,
};

TextAreaFormik.defaultProps = {
  additionalProps: {},
  className: '',
  maxRows: 8,
  required: false,
  type: 'text',
};

export default TextAreaFormik;
